import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  style: {"overflow-y":"hidden","overflow-x":"scroll"},
  class: "full-width"
}
const _hoisted_2 = {
  key: 0,
  class: "row no-wrap justify-left"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  key: 3,
  class: "q-mt-md",
  style: {"font-weight":"normal"}
}
const _hoisted_7 = {
  key: 1,
  style: {"text-align":"center","margin-top":"100px","width":"100%"}
}
const _hoisted_8 = { style: {"display":"block"} }
const _hoisted_9 = { class: "text-h6" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  style: {"display":"inline-block","width":"100%","margin-top":"22px !important","background-color":"white","padding":"10px","border":"1px solid #e0e0e0","border-radius":"4px"}
}
const _hoisted_12 = {
  class: "full-width text-h6",
  style: {"border-bottom":"1px solid #e0e0e0","padding":"5px"}
}
const _hoisted_13 = {
  style: {"width":"100%","min-height":"100vh"},
  class: "q-my-lg"
}
const _hoisted_14 = { class: "text-h6" }
const _hoisted_15 = {
  key: 0,
  style: {"width":"100%","flex":"1 1 0","min-height":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MostaSelect = _resolveComponent("MostaSelect")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_v_chart = _resolveComponent("v-chart")!
  const _component_formula_selector = _resolveComponent("formula-selector")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_QTLiteSkeleton = _resolveComponent("QTLiteSkeleton")!
  const _component_query_table = _resolveComponent("query-table")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.inPreviewMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MostaSelect, {
            modelValue: _ctx.widthModel,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.widthModel) = $event)),
            options: _ctx.widthOptions,
            style: {"min-width":"180px","margin-top":"6px","margin-left":"5px","margin-right":"5px"}
          }, null, 8, ["modelValue", "options"]),
          _withDirectives(_createVNode(_component_MostaSelect, {
            modelValue: _ctx.elementWidthModel,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.elementWidthModel) = $event)),
            options: _ctx.elementWidthOptions,
            style: {"min-width":"180px","margin-top":"6px","margin-left":"5px","margin-right":"5px"}
          }, null, 8, ["modelValue", "options"]), [
            [_vShow, _ctx.scaleLinear]
          ]),
          (_ctx.genstore.selectedItem && _ctx.genstore.selectedItem.Id)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "qt-panel-icon-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onRefreshClick && _ctx.onRefreshClick(...args))),
                "aria-label": _ctx.$t('refresh_label')
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("svg", {
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M17.5 10C17.5 11.4834 17.0601 12.9334 16.236 14.1668C15.4119 15.4001 14.2406 16.3614 12.8701 16.9291C11.4997 17.4968 9.99168 17.6453 8.53683 17.3559C7.08197 17.0665 5.7456 16.3522 4.6967 15.3033C3.64781 14.2544 2.9335 12.918 2.64411 11.4632C2.35472 10.0083 2.50325 8.50032 3.07091 7.12987C3.63856 5.75943 4.59986 4.58809 5.83323 3.76398C7.0666 2.93987 8.51664 2.5 10 2.5C12.1 2.5 14.1083 3.33333 15.6167 4.78333L17.5 6.66667",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M17.5 2.5V6.66667H13.3333",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                _createVNode(_component_q_tooltip, {
                  delay: 300,
                  anchor: "top middle",
                  self: "center middle"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('refresh_label')), 1)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_3))
            : _createCommentVNode("", true),
          (!_ctx.querystore.isLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "qt-panel-icon-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveChartToFile && _ctx.saveChartToFile(...args))),
                "aria-label": _ctx.$t('load')
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("svg", {
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M10 12.5V2.5",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M5.83331 8.33337L9.99998 12.5L14.1666 8.33337",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                _createVNode(_component_q_tooltip, {
                  delay: 300,
                  anchor: "top middle",
                  self: "center middle"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('load')), 1)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.genstore.selectedItem)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "qt-panel-icon-btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.copyLinkToItem && _ctx.copyLinkToItem(...args))),
                "aria-label": _ctx.$t('copy_link')
              }, [
                _cache[10] || (_cache[10] = _createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.5 6C15.3284 6 16 5.32843 16 4.5C16 3.67157 15.3284 3 14.5 3C13.6716 3 13 3.67157 13 4.5C13 5.32843 13.6716 6 14.5 6Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.5 11C6.32843 11 7 10.3284 7 9.5C7 8.67157 6.32843 8 5.5 8C4.67157 8 4 8.67157 4 9.5C4 10.3284 4.67157 11 5.5 11Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14.5 16C15.3284 16 16 15.3284 16 14.5C16 13.6716 15.3284 13 14.5 13C13.6716 13 13 13.6716 13 14.5C13 15.3284 13.6716 16 14.5 16Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.15833 11.2583L12.85 14.575\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12.8417 5.42505L7.15833 8.74172\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)),
                _createVNode(_component_q_tooltip, {
                  delay: 300,
                  anchor: "top middle",
                  self: "center middle"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('copy_link')), 1)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.modelValue && _ctx.modelValue.LastForceRecalculatedAt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " (" + _toDisplayString(_ctx.$t('current_at')) + " " + _toDisplayString(_ctx.lastCalcDate) + ") ", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.querystore.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_q_spinner_dots, {
            color: "primary",
            size: "2em"
          })
        ]))
      : (_ctx.displaying)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            style: _normalizeStyle('width: '+((_ctx.inPreviewMode ? 1 : _ctx.widthMultiplier)*100)+'%; display: flex; flex-flow: column;')
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.option, (opt, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'chart_'+index,
                    style: _normalizeStyle(`height: ${_ctx.theModel.ChartType === 0 ? (!_ctx.scaleLinear ? '80vh' : Math.floor(70*_ctx.elementWidthMultiplierDraw)+'vh') : ((index === _ctx.option.length-1) && ((index+1) % 2 !== 0) || 
              (_ctx.theModel as AnalyticsPieChartBundleResult).DisplayType === 1 ? Math.floor(_ctx.chart_height*_ctx.elementWidthMultiplierDraw) : Math.floor(_ctx.chart_height*_ctx.elementWidthMultiplierDraw))+'px'
            }; ${!_ctx.inPreviewMode ? 'float: left; margin: 30px;' : 'margin: 0 auto;'} width: ${_ctx.theModel.ChartType === 0 ? (!_ctx.scaleLinear ? '95%' : Math.floor(95*_ctx.elementWidthMultiplierDraw)+'%') : Math.floor(_ctx.chart_width*_ctx.elementWidthMultiplierDraw)+'px'};`)
                  }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(opt.title.custom_text), 1),
                    _createElementVNode("div", {
                      class: "text-h8 text-blue cursor-pointer",
                      style: {"text-decoration":"underline"},
                      onClick: ($event: any) => (_ctx.onRepeatingClick($event, index, opt.repeating))
                    }, _toDisplayString(opt.title.custom_subtext), 9, _hoisted_10),
                    _createVNode(_component_v_chart, {
                      style: {"margin-top":"5px"},
                      option: opt,
                      "init-options": { width: 'auto', height: 'auto' },
                      onClick: ($event: any) => (_ctx.onChartClick($event, index)),
                      onFinished: _ctx.onChartRendered,
                      autoresize: "",
                      ref_for: true,
                      ref: "chart"
                    }, null, 8, ["option", "onClick", "onFinished"])
                  ], 4))
                }), 128))
              ]),
              (_ctx.currentTokens && _ctx.currentTokens.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.sectorName) + ":", 1),
                    _withDirectives(_createVNode(_component_formula_selector, {
                      "input-parameter-options": _ctx.graphstore.getCurrentFormulas,
                      "input-index": 0,
                      "nested-key-name": "ChildFormulas",
                      "template-name": "Entity",
                      "formula-options": [],
                      "global-formulas-mode": true,
                      "is-incorrect": "",
                      "read-only": true,
                      modelValue: _ctx.currentTokens,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentTokens) = $event))
                    }, null, 8, ["input-parameter-options", "modelValue"]), [
                      [_vShow, _ctx.currentTokens && _ctx.currentTokens.length]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "row items-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.sectorName || _ctx.$t('chart_sector_report')), 1),
                      _createVNode(_component_q_space),
                      _withDirectives(_createVNode(_component_q_btn, {
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: "",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSectorTable = false))
                      }, null, 512), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_section, { style: {"display":"flex"} }, {
                    default: _withCtx(() => [
                      (_ctx.auxstore.isTableLoading && !(_ctx.sectorTableModel && (_ctx.sectorTableModel as AnalyticsResultTableExtended).HeaderRow))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_QTLiteSkeleton)
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_query_table, {
                        class: "full-width",
                        "src-element": _ctx.genstore.selectedItem,
                        "is-sector": true,
                        "sector-entity-ids": _ctx.entity_ids,
                        paginationModel: _ctx.pagination,
                        "onUpdate:paginationModel": _ctx.onUpdatePagination,
                        selectedEverything: _ctx.selectedAll,
                        "onUpdate:selectedEverything": _ctx.onSelectedAllUpdate,
                        selectedEntities: _ctx.selectedEntities,
                        "onUpdate:selectedEntities": _ctx.onSelectionUpdate,
                        unselectedEntities: _ctx.unselectedEntities,
                        "onUpdate:unselectedEntities": _ctx.onUnSelectionUpdate,
                        onMovePage: _ctx.onMovePage,
                        onRefreshPage: _ctx.onRefreshPage,
                        modelValue: _ctx.sectorTableModel,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sectorTableModel) = $event))
                      }, null, 8, ["src-element", "sector-entity-ids", "paginationModel", "onUpdate:paginationModel", "selectedEverything", "onUpdate:selectedEverything", "selectedEntities", "onUpdate:selectedEntities", "unselectedEntities", "onUpdate:unselectedEntities", "onMovePage", "onRefreshPage", "modelValue"]), [
                        [_vShow, _ctx.sectorTableModel && 
              (_ctx.sectorTableModel as AnalyticsResultTableExtended).HeaderRow]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.showSectorTable]
              ])
            ])
          ], 4))
        : _createCommentVNode("", true)
  ]))
}